import React from "react";

export default (props) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.33795 5.33795C5.78856 4.88735 6.51913 4.88735 6.96974 5.33795L10 8.36823L13.0303 5.33799C13.4809 4.88738 14.2114 4.88738 14.662 5.33799C15.1127 5.78859 15.1127 6.51917 14.662 6.96977L11.6318 10L14.662 13.0302C15.1126 13.4808 15.1126 14.2114 14.662 14.662C14.2114 15.1126 13.4808 15.1126 13.0302 14.662L10 11.6318L6.96977 14.662C6.51917 15.1127 5.78859 15.1127 5.33799 14.662C4.88738 14.2114 4.88738 13.4809 5.33799 13.0303L8.36823 10L5.33795 6.96974C4.88735 6.51913 4.88735 5.78856 5.33795 5.33795Z"
        fill="#747474"
        fillOpacity="0.6"
      />
    </svg>
  );
};
